// extracted by mini-css-extract-plugin
export default {"hidden":"Header_hidden__LWXR0","wrapper":"Header_wrapper__SXTn0","title":"Header_title__l+wMf","nav":"Header_nav__IIF23"};